import { render, staticRenderFns } from "./ContentFooter.vue?vue&type=template&id=0841f88e&scoped=true"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"
import style0 from "./ContentFooter.vue?vue&type=style&index=0&id=0841f88e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0841f88e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/74a6e498-56df-5c0c-aa3e-2f5fe39d1378/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0841f88e')) {
      api.createRecord('0841f88e', component.options)
    } else {
      api.reload('0841f88e', component.options)
    }
    module.hot.accept("./ContentFooter.vue?vue&type=template&id=0841f88e&scoped=true", function () {
      api.rerender('0841f88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/ContentFooter.vue"
export default component.exports